import {
  Fragment,
  ReactNode,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import ProjectCard, {
  ProjectTypeEnum,
} from "@/pages/CreationSpace/components/ProjectCard/ProjectCard";
import MaterialCard, {
  CardTypeEnum,
  IMaterialRef,
} from "@/pages/CreationSpace/components/MaterialCard/MaterialCard";
import {
  IconCopy,
  IconDelete,
  IconExport,
  IconLoading,
} from "@arco-design/web-react/icon";
import {
  Button,
  Image,
  Message,
  ModalProps,
  Pagination,
  Popover,
  Spin,
} from "@arco-design/web-react";
import ActionBar from "@/pages/CreationSpace/components/ActionBar/ActionBar";
import DetailCard from "@/pages/CreationSpace/components/DetailCard/FolderDetail/DetailCard";
import MoveModal from "@/pages/CreationSpace/components/MoveModal/MoveMaterialModal";
import ActionBarItem from "@/pages/CreationSpace/components/ActionBar/ActionBarItem";
import LinkProjectModal from "./LinkProjectModal/LinkProjectModal";
import BatchAction from "../BatchAction/BatchAction";
import RefTipModal from "@/pages/CreationSpace/components/RefTipModal/RefTipModal";
import RemoveTipModal from "../RemoveTipModal/RemoveTipModal";
import CreateFolderModal from "../SearchOpeator/CreateFolderModal/CreateFolderModal";
import SearchOpeator from "../SearchOpeator/SearchOpeator";
import { MATERIALTABLIST } from "@/mock/space/space";
import copyImg from "@/assets/create-space/copy.png";
import downloadImg from "@/assets/create-space/download.png";
import moveImg from "@/assets/create-space/move.png";
import deleteImg from "@/assets/create-space/delete.png";
import renameImg from "@/assets/create-space/rename.png";
import linkImg from "@/assets/create-space/link.png";
import detailImg from "@/assets/create-space/detail.png";
import cutImg from "@/assets/cut-mix-detail/detail-cut.png";
import useProject from "@/useStore/createspace/useProject";
import UploadMaterialFile from "./MaterialEmpty/UploadMaterialFile/UploadMaterialFile";
import allowTypeStore from "@/stores/allowTypeStore";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import { debounce } from "lodash";
import downLoadImg1 from "@/assets/cut-mix-detail/download.png";
import {
  IMoveRequest,
  SourceType,
  batch_download,
  copyToFileAndFolder,
  moveFileAndFolder,
} from "@/services/createSpace/material";
import { formatTime } from "@/components/business/VideoHoc/VideoHoc";
import useRename from "@/requestHooks/createSpace/material/useRename";
import useDeleteMaterial from "@/requestHooks/createSpace/material/useDeleteMaterial";
import useCopyMaterialsAndFolders from "@/requestHooks/createSpace/material/useCopyMaterialsAndFolders";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import {
  IGetMaterialSearch,
  getMetarialData,
} from "@/services/createSpace/graphQ/getMetarialList";
import {
  IMaterialDetail,
  getUpdateTime,
} from "@/services/createSpace/graphQ/getSimpleMedia";
import { throttle } from "echarts";
import { IFolder } from "../BreadCrumb/BreadCrumb";
import UploadMaskBlock from "@/components/business/UploadMaskBlock/UplaodMaskBlock";
import { add_folder_icon } from "@/assets/creationscriptimage";
import "./Material.less";
import PlayerModal, { IPlayModal } from "../PlayerModal/PlayerModal";
import { downloadAsZip } from "@/utils/zip";
import useNavigateTo from "@/utils/useNavigateTo";
import ClipDrawer from "@/components/business/ClipDrawer";
import ImageCropper from "@/pages/CreationSpace/CreativeSpace/CreativeContainer/components/Material/ImageCropper";
import useFileUpload from "./enum";
import FolderList from "./FolderList/FolderList";

export const getCheckboxState = (arr: string[], name: string) => {
  return arr.indexOf(name) > -1;
};

const toTypeGetSourceType = (type: CardTypeEnum): SourceType => {
  switch (type) {
    case CardTypeEnum.MOVIE:
      return "video";
    case CardTypeEnum.MUSIC:
      return "music_sound";
    case CardTypeEnum.PICTURE:
      return "background";
    default:
      return null;
  }
};

export interface IActionBarItem {
  text: string;
  icon: ReactNode;
  handleItemClick: (id: number, item: IMaterialDetail) => Promise<void>;
  popover?: boolean;
}

export interface IMaterialProps {
  folderId: number;
  folderList: IFolder[];
  onFolderInto: (e: any, cb?: Function) => void;
  clearFolderList: () => void;
}

export const Material: React.FC<IMaterialProps> = observer((props) => {
  const { folderId, onFolderInto, clearFolderList, folderList } = props;
  const { progress, uploadState, hanldeUploadFile } = useFileUpload();
  const folderRef = useRef(null)
  const { projectId } = useProject();
  const refs = useRef<IMaterialRef[]>([]);
  const [downLoading, setDownLoading] = useState(false);
  const { navigateTo } = useNavigateTo();
  const {
    handleRequest,
    searchData,
    pageParams,
    data,
    loading,
    handlePageChange,
    setSearchData,
  } = useRequest<IMaterialDetail, IGetMaterialSearch>({
    manual: true,
    request: getMetarialData,
    initSearchData: {
      parentId: folderId ? folderId : 0,
      projectId: null,
      type: [1,2,3] as number[],
      sortSc: "desc",
      keyword: "",
      sort_field: "created_at",
    },
    page: {
      page: 1,
      page_size: 20,
    },
  });
  const uploadRef = useRef(null);
  const clipDrawerRef = useRef(null);
  const { handleRenameRequest } = useRename();
  const { handleMetarialDelete } = useDeleteMaterial();
  const { handleCopyFile } = useCopyMaterialsAndFolders();
  const [linkProjectModalVisible, setLinkProjectModalVisible] = useState(false);
  const [collection, setCollection] = useState([]);
  const [tipModalState, setTipModalState] = useState(false);
  const [moveAndCopyState, setMoveAndCopyState] = useState<"move" | "copy">(
    null
  );
  const [showLoading, setShowLoading] = useState(false);
  const [moveModalTitlVisble, setMoveModalTitleVisible] = useState(false);
  const [cropperVisible, setCropperVisible] = useState(false);
  const [cropperUrl, setCropperUrl] = useState("");
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [cropperImageName, setCropperImageName] = useState("");

  const [mediaIdList, setMediaIdList] = useState([]);
  const [editId, setEditId] = useState(null);
  const [createFolderModalVisible, setCreateFolderModalVisible] =
    useState(false);
  const [linkMaterial, setLinkMaterial] = useState<{
    id: number;
    type: SourceType;
  }>({
    id: null,
    type: null,
  });
  const [currentPlayModal, setCurrentPlayModal] = useState<
    Omit<IPlayModal, keyof ModalProps> & { visible: boolean }
  >({
    playUrl: null,
    name: null,
    type: null,
    visible: false,
  });

  const throttledHandleRequest = useCallback(
    throttle((keyword: string) => {
      handleRequest({ ...searchData, projectId, keyword });
    }, 300),
    [searchData, projectId]
  );

  const handleInputChange = (e) => {
    setSearchData((prevData) => {
      const newData = { ...prevData, keyword: e };
      throttledHandleRequest(e);
      return newData;
    });
  };
  const dataURLtoBlob = (dataurl) => {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const cropperOk = async (url) => {
    setCropperUrl(url);
    setCropperVisible(false);
    try {
      // const response = await fetch(url);
      // console.log(response, 'response')
      // const blob = await response.blob();
      console.log(url, "url");
      const blob = dataURLtoBlob(url);
      console.log(blob.type, "blob.type");
      const file = new File([blob], cropperImageName, { type: blob.type });
      Message.info({ content: "图片裁剪中..." });
      hanldeUploadFile(file, {
        floderId: folderId || 0,
        projectId,
        filename: cropperImageName,
        size: file.size,
      });
    } catch (error) {
      console.error("Error getting image info:", error);
    }
  };

  const deleteBatchOrBatch = debounce(async (state: boolean) => {
    try {
      await handleMetarialDelete(editId || collection, data, state);
      setEditId(null);
      if (collection && collection.length > 0) {
        setCollection([]);
      }
      handleRequest({ ...searchData });
    } catch (e) {
      console.log(e);
      Message.error(e);
    } finally {
      setDeleteVisible(false);
    }
  }, 500);

  const handleChangeCollection = (
    name: string,
    e: boolean,
    media_id?: string
  ) => {
    if (e) {
      const newCollection = [...collection];
      newCollection.push(name);

      setCollection(newCollection);
      mediaIdList.push(media_id);
    } else {
      const index = collection.indexOf(name);
      const mid = mediaIdList.findIndex((item) => item === media_id);
      mediaIdList.splice(mid, 1);
      if (index > -1) {
        const newCollection = [...collection];
        newCollection.splice(index, 1);
        setCollection(newCollection);
      }
    }
    setMediaIdList([...mediaIdList]);
  };

  const getMaterialActionBar = (item: any): IActionBarItem[] => {
    return [
      {
        text: "重命名",
        icon: <img src={renameImg} alt="" />,
        handleItemClick: async (_, item) => {
          const index = data.findIndex((step) => step.id === item.id);
          refs.current[index].toggleIsEdit();
          refs.current[index].setIsTriggerActive(true);
        },
      },
      {
        text: "复制",
        icon: <img src={copyImg} alt="" />,
        handleItemClick: async (_, item) => {
          try {
            await handleCopyFile(item.id, projectId);
            handleRequest({ ...searchData });
          } catch (e) {
            console.log(e);
          }
        },
      },
      {
        text: "移动",
        icon: <img src={moveImg} alt="" />,
        handleItemClick: async (e, item) => {
          setEditId(item.id);
          setMoveAndCopyState("move");
          setMoveModalTitleVisible(true);
        },
      },
      {
        text: "关联工程",
        icon: <img src={linkImg} alt="" />,
        handleItemClick: async (e, item) => {
          setLinkMaterial({
            id: e,
            type: toTypeGetSourceType(item.type as CardTypeEnum),
          });
          setLinkProjectModalVisible(true);
        },
      },
      {
        text: "下载",
        icon: <img src={downloadImg} alt="" />,
        handleItemClick: async (_, item) => {
          try {
            const res = await batch_download({
              media_id: [item.media_id],
            });
            // window.open(res.data.items[0].url, "_blank");
            navigateTo(res.data.items[0].url);
            Message.success("下载成功，请到浏览下载查看！");
          } catch (e) {
            Message.error("下载失败，请刷新后重试！");
          }
        },
      },
      ...(item.type === CardTypeEnum.PICTURE
        ? [
            {
              text: "编辑",
              icon: <img src={cutImg} />,
              handleItemClick: async (e, item) => {
                console.log(item);
                // clipDrawerRef.current.open(item);
                setCropperUrl(item.play_info.cover_url);
                setCropperVisible(true);
                setCropperImageName(
                  item.name.split(".")[0] +
                    "_副本." +
                    (item.name.split(".")[1] || item.format_name)
                );
              },
            },
          ]
        : []),
      ...(item.type === CardTypeEnum.MOVIE
        ? [
            {
              text: "编辑",
              icon: <img src={cutImg} />,
              handleItemClick: async (e, item) => {
                clipDrawerRef.current.open(item);
              },
            },
          ]
        : []),
      {
        text: "删除",
        icon: <img src={deleteImg} />,
        handleItemClick: async (e, item) => {
          setDeleteVisible(true);
          setEditId(e);
        },
      },
      {
        text: "详情",
        icon: <img src={detailImg} />,
        handleItemClick: async (e, item) => {
          console.log(e);
        },
        popover: true,
      },
    ];
  };

  const getFolderActionBar = (item): IActionBarItem[] => [
    {
      text: "重命名",
      icon: <img src={renameImg} alt="" />,
      handleItemClick: async (_, item) => {
        const index = data.findIndex((step) => step.id === item.id);
        refs.current[index].toggleIsEdit();
      },
    },
    {
      text: "复制",
      icon: <img src={copyImg} alt="" />,
      handleItemClick: async (_, item) => {
        await handleCopyFile(item.id, projectId);
        handleRequest({ ...searchData });
      },
    },

    {
      text: "移动",
      icon: <img src={moveImg} alt="" />,
      handleItemClick: async (e, item) => {
        setMoveAndCopyState("move");
        setEditId(item.id);
        setMoveModalTitleVisible(true);
      },
    },
    {
      text: "删除",
      icon: <img src={deleteImg} alt="" />,
      handleItemClick: async (e, item) => {
        setDeleteVisible(true);
        setEditId(e);
      },
    },
  ];

  const hanldeFolderItemClick = (item: IMaterialDetail & {isLeaf: any, parentData: any}) => {
    // handlePageChange({ page: 1, page_size: 20 });
    onFolderInto(
      {
        id: item.id,
        name: item.name,
        updated_at: getUpdateTime(item.updated_at),
        created_at: getUpdateTime(item.created_at),
        creator: item.creator,
        isLeaf: item.isLeaf,
        parentData: item.parentData
      },
      () => {
        setTimeout(() => {
          setShowLoading(false);
        }, 500);
      }
    );
  };

  useEffect(() => {
    if (projectId) {
      setCollection([]);
      handleRequest({
        ...searchData,
        projectId,
        parentId: folderId ? folderId : 0,
      });
    }
  }, [projectId, folderId]);

  useEffect(() => {
    if (uploadState === "success") {
      Message.success({ content: "编辑成功，已保存为新图片" });
      setTimeout(() => {
        handleRequest({ ...searchData });
      }, 10);
    }
  }, [uploadState]);

  useEffect(() => {
    return () => {
      clearFolderList();
    };
  }, []);

  return (
    <div className="create-space-material-wrapper">
      <div style={{ display: 'flex' }}>
      <FolderList ref={folderRef} projectId={projectId} folderId={folderId} onFolderClick={(row) => hanldeFolderItemClick(row)}/>
      <div style={{ flex: 1 }}>
        <div className="create-sapce-meterial-search-wrapper">
        {collection && collection.length > 0 ? (
          <BatchAction
            disabled={loading === "loading"}
            total={data.length}
            collection={collection}
            buttonList={
              <>
                <Button
                  loading={downLoading}
                  style={{ marginRight: "17px" }}
                  type="outline"
                  onClick={async () => {
                    try {
                      setDownLoading(true);
                      const res = await batch_download({
                        media_id: mediaIdList,
                      });
                      const urls = res.data.items.map((item) => item.url);
                      if (urls?.length > 0) {
                        downloadAsZip(urls, () => {
                          setDownLoading(false);
                        });
                        Message.success("下载成功，请到浏览下载查看！");
                      }
                    } catch (e) {
                      Message.error("下载失败，请刷新后重试！");
                      setDownLoading(false);
                    }
                    // try {
                    //   const downLoadList = [];
                    //   const fileList = [];
                    //   data.forEach((item) => {
                    //     if (collection.includes(item.id)) {
                    //       if (item.type === ProjectTypeEnum.FOLDER) {
                    //         fileList.push(item.id);
                    //       }
                    //       if (item.type === CardTypeEnum.MOVIE) {
                    //         downLoadList.push(item.play_info.play_url);
                    //       }
                    //
                    //       if (item.type === CardTypeEnum.PICTURE) {
                    //         downLoadList.push(item.play_info.cover_url);
                    //       }
                    //       if (item.type === CardTypeEnum.MUSIC) {
                    //         downLoadList.push(item.play_info.play_url);
                    //       }
                    //     }
                    //   });
                    //   if (fileList.length > 0) {
                    //     Message.error("文件夹无法下载!");
                    //   }
                    //   console.log(collection, 'collection')
                    //   // downloadAsZip(downLoadList);
                    // } catch (e) {
                    //   console.log(e);
                    //   Message.error("下载失败，请刷新后重试！");
                    // }
                  }}
                  icon={
                    <Image
                      width={20}
                      height={20}
                      src={downLoadImg1}
                      preview={false}
                    />
                  }
                >
                  <span style={{ marginLeft: 5 }}>批量下载</span>
                </Button>
                <Button
                  style={{ marginRight: "17px" }}
                  type="outline"
                  onClick={async () => {
                    setDeleteVisible(true);
                  }}
                  icon={<IconDelete />}
                >
                  删除
                </Button>
                <Button
                  style={{ marginRight: "17px" }}
                  type="outline"
                  onClick={() => {
                    setMoveAndCopyState("move");
                    setMoveModalTitleVisible(true);
                  }}
                  icon={<IconExport />}
                >
                  移动到
                </Button>
                <Button
                  type="outline"
                  onClick={() => {
                    setMoveAndCopyState("copy");
                    setMoveModalTitleVisible(true);
                  }}
                  icon={<IconCopy />}
                >
                  复制到
                </Button>
              </>
            }
            handleCancel={() => {
              setCollection([]);
              setMediaIdList([]);
            }}
            handleSelectAll={() => {
              setCollection([...data.map((item) => item.id)]);
              setMediaIdList([...data.map((item) => item.media_id)]);
            }}
          />
        ) : (
          <SearchOpeator
            handleFilterFiledChange={(e) => {
              handleRequest({ ...searchData, sort_field: e });
            }}
            tabList={MATERIALTABLIST}
            tabListActiveId={searchData.type.length > 2 ? undefined : searchData.type[0]}
            filterOption={[
              {
                label: "按创建时间排序",
                value: "created_at",
              },
              {
                label: "按更新时间排序",
                value: "updated_at",
              },
              {
                label: "按文件大小排序",
                value: "file_size",
              },
            ]}
            filteFiled={searchData.sort_field}
            handleKeyWordsChange={handleInputChange}
            keyword={searchData.keyword}
            sc={searchData.sortSc}
            handleScChange={(e) => {
              const data = {
                ...searchData,
                sortSc: e,
              };
              handleRequest(data);
            }}
            handleTabButtonClick={(e) => {
              let type = [e]
              if (!e) {
                type = [1,2,3]
              }
              const data = {
                ...searchData,
                type: type,
              };
              handleRequest(data);
            }}
            buttonList={
              folderList.length > 2 ? (
                <></>
              ) : (
                // <Button
                //   type="outline"
                //   onClick={() => {
                //     setCreateFolderModalVisible(true);
                //   }}
                //   icon={
                //     <Image
                //       src={add_folder_icon}
                //       style={{ marginRight: 4, marginTop: -5 }}
                //       width={16}
                //       preview={false}
                //     />
                //   }
                //   style={{
                //     borderRadius: "4px",
                //     height: 38,
                //   }}
                // >
                //   <span style={{ paddingLeft: 8 }}>新建文件夹</span>
                // </Button>
                null
              )
            }
          />
        )}
        </div>
        <div className="create-space-material-container">
          <Spin
            loading={loading === "loading"}
            size={30}
            className="create-space-data-container"
            style={{ width: "100%" }}
            icon={<IconLoading />}
          >
            <div className="data-container">
              <div className="container-box" style={{ marginTop: 0}}>
                {
                  folderId && <UploadMaskBlock
                        style={{ width: 180, height: 230 }}
                        hoverable={false}
                        onClick={() => {
                          uploadRef.current?.upload();
                        }}
                    >
                        <UploadMaskBlock.Item>
                            <UploadMaterialFile
                                ref={uploadRef}
                                folderId={folderId || 0}
                                handleOKBtnClick={() => {
                                  handleRequest({ ...searchData });
                                }}
                                allowType={toJS(allowTypeStore.getAllowTypeString())}
                                handleFileChange={(e) => {
                                  console.log(e);
                                }}
                            />
                        </UploadMaskBlock.Item>
                    </UploadMaskBlock>
                }
                {showLoading && (
                  <div
                    className={"showloading"}
                    style={{ display: showLoading ? "flex" : "none" }}
                  >
                    {showLoading && <Spin size={30} />}
                  </div>
                )}
                {data && data.length > 0 ? (
                  <>
                    {!showLoading &&
                      data.map((item: any, index) => {
                        return (
                          <div key={item.id}>
                            {item.type === ProjectTypeEnum.FOLDER ? (
                              <ProjectCard
                                disRename={true}
                                id={item.id}
                                isCardClickPrevented={collection.length > 0}
                                onClick={() => {
                                  setShowLoading(true);
                                  console.log(item, 'item-item')
                                  hanldeFolderItemClick(item);
                                }}
                                type={ProjectTypeEnum.FOLDER}
                                checkBoxState={getCheckboxState(
                                  collection,
                                  item.id
                                )}
                                updateTime={getUpdateTime(item.updated_at)}
                                {...(item as any)}
                                isOperate={true}
                                ref={(ele) =>
                                  (refs.current[index] = ele as IMaterialRef)
                                }
                                handleInputEndEnter={async (e) => {
                                  try {
                                    await handleRenameRequest(e, item.id);
                                    refs.current[index].toggleIsEdit();
                                    handleRequest({ ...searchData });
                                  } catch (e) {
                                    console.log(e);
                                  }
                                }}
                                handleCheckboxChange={(e) => {
                                  handleChangeCollection(
                                    item.id,
                                    e,
                                    item.media_id
                                  );
                                }}
                                actionBar={
                                  <ActionBar>
                                    {getFolderActionBar(item).map(
                                      (step, index) => {
                                        return (
                                          <Fragment key={index}>
                                            <ActionBarItem
                                              text={step.text}
                                              icon={step.icon}
                                              onClick={() => {
                                                step.handleItemClick(
                                                  Number(item.id),
                                                  item
                                                );
                                              }}
                                            />
                                          </Fragment>
                                        );
                                      }
                                    )}
                                  </ActionBar>
                                }
                                handleInputEndChange={(e) => {
                                  refs.current[index].toggleIsEdit();
                                }}
                              />
                            ) : (
                              <>
                                <MaterialCard
                                  onClick={() => {
                                    const newCurrentPlayModal = {
                                      ...currentPlayModal,
                                    };
                                    if (item.type === CardTypeEnum.MOVIE) {
                                      newCurrentPlayModal.type = "video";
                                      newCurrentPlayModal.playUrl =
                                        item.play_info.play_url;
                                    }
                                    if (item.type === CardTypeEnum.MUSIC) {
                                      newCurrentPlayModal.type = "music";
                                      newCurrentPlayModal.playUrl =
                                        item.play_info.play_url;
                                    }
                                    if (
                                      item.type === CardTypeEnum.PICTURE ||
                                      item.type === 0
                                    ) {
                                      newCurrentPlayModal.type = "picture";
                                      newCurrentPlayModal.playUrl =
                                        item?.play_info?.cover_url;
                                    }

                                    newCurrentPlayModal.name = item.name;
                                    newCurrentPlayModal.visible = true;
                                    console.log(item);
                                    setCurrentPlayModal(newCurrentPlayModal);
                                  }}
                                  updateTime={getUpdateTime(item.updated_at)}
                                  isOperate={true}
                                  disRename={true}
                                  checkBoxState={getCheckboxState(
                                    collection,
                                    item.id
                                  )}
                                  time={formatTime(item.duration)}
                                  {...(item as any)}
                                  img={item?.play_info?.cover_url || null}
                                  handleCheckboxChange={(e) => {
                                    handleChangeCollection(
                                      item.id,
                                      e,
                                      item.media_id
                                    );
                                  }}
                                  ref={(ele) => {
                                    refs.current[index] = ele;
                                  }}
                                  handleInputEndEnter={async (e) => {
                                    try {
                                      await handleRenameRequest(e, item.id);
                                      refs.current[index].toggleIsEdit();
                                      handleRequest({ ...searchData });
                                    } catch (e) {
                                      console.log(e);
                                    }
                                  }}
                                  actionBar={
                                    <ActionBar>
                                      {getMaterialActionBar(item).map(
                                        (step, index) => {
                                          if (!step.popover) {
                                            return (
                                              <Fragment key={index}>
                                                <ActionBarItem
                                                  text={step.text}
                                                  icon={step.icon}
                                                  onClick={() => {
                                                    step.handleItemClick(
                                                      Number(item.id),
                                                      item
                                                    );
                                                  }}
                                                />
                                              </Fragment>
                                            );
                                          } else {
                                            return (
                                              <Fragment key={index}>
                                                <Popover
                                                  position="rt"
                                                  trigger={"click"}
                                                  content={
                                                    <DetailCard
                                                      creator={item.creator}
                                                      name={item.name}
                                                      resolution={`${item.width} * ${item.height}`}
                                                      size={`${item.file_size}`}
                                                      type={`${item.format_name}`}
                                                      count={Number(
                                                        item.use_by_session
                                                      )}
                                                      create_at={getUpdateTime(
                                                        item.created_at
                                                      )}
                                                      update_at={getUpdateTime(
                                                        item.updated_at
                                                      )}
                                                      shooting_theme={
                                                        item.shooting_theme
                                                      }
                                                    />
                                                  }
                                                >
                                                  <ActionBarItem
                                                    text={step.text}
                                                    icon={step.icon}
                                                    onClick={() => {
                                                      step.handleItemClick(
                                                        Number(item.id),
                                                        item
                                                      );
                                                    }}
                                                  />
                                                </Popover>
                                              </Fragment>
                                            );
                                          }
                                        }
                                      )}
                                    </ActionBar>
                                  }
                                />
                              </>
                            )}
                          </div>
                        );
                      })}
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="pagination-wrapper-space">
              {data && data.length > 0 ? (
                <>
                  <Pagination
                    sizeOptions={[10, 15, 20, 25, 30, 50]}
                    showTotal={(total) => `共 ${total}条`}
                    total={pageParams.total}
                    showJumper
                    sizeCanChange
                    defaultPageSize={Number(pageParams.page_size)}
                    pageSize={Number(pageParams.page_size)}
                    current={Number(pageParams.page)}
                    onChange={(page, pageSize) => {
                      handlePageChange({ page, page_size: pageSize });
                    }}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
          </Spin>
        </div>
      </div>
      </div>
      {createFolderModalVisible ? (
        <CreateFolderModal
          projectId={projectId}
          handleOnBtnClick={() => {
            handleRequest({ ...searchData });
            setCreateFolderModalVisible(false);
          }}
          onCancel={() => {
            setCreateFolderModalVisible(false);
          }}
          visible={createFolderModalVisible}
          folderName={folderList[folderList.length - 1]?.name || null}
        />
      ) : (
        <></>
      )}
      {deleteVisible ? (
        <RemoveTipModal
          visible={deleteVisible}
          title={"删除提示"}
          handleDeleteBtnClick={async () => {
            deleteBatchOrBatch(true);
          }}
          handleHiddenDeleteBtnClick={async () => {
            deleteBatchOrBatch(false);
          }}
          onCancel={() => {
            setDeleteVisible(false);
          }}
        />
      ) : (
        <></>
      )}
      {linkProjectModalVisible ? (
        <LinkProjectModal
          projectId={projectId}
          onCancel={() => {
            setLinkProjectModalVisible(false);
          }}
          visible={linkProjectModalVisible}
          id={linkMaterial.id}
          type={linkMaterial.type}
        />
      ) : (
        <></>
      )}
      {tipModalState ? (
        <RefTipModal
          visible={tipModalState}
          onCancel={() => {
            setTipModalState(false);
          }}
          onOk={() => {
            setTipModalState(false);
          }}
        />
      ) : (
        <></>
      )}
      {currentPlayModal.visible ? (
        <PlayerModal
          visible={currentPlayModal.visible}
          playUrl={currentPlayModal.playUrl}
          name={currentPlayModal.name}
          type={currentPlayModal.type}
          onCancel={() => {
            setCurrentPlayModal({
              visible: false,
              name: null,
              type: null,
              playUrl: null,
            });
          }}
          onConfirm={() => {
            setCurrentPlayModal({
              visible: false,
              name: null,
              type: null,
              playUrl: null,
            });
          }}
        />
      ) : (
        <></>
      )}
      {moveModalTitlVisble ? (
        <MoveModal
          fileTitleName={moveAndCopyState}
          visible={moveModalTitlVisble}
          onCancel={() => {
            setMoveModalTitleVisible(false);
            setEditId(null);
            if (moveAndCopyState === "move") folderRef.current?.getTreeData();
          }}
          onOk={async (projectId: number, e: number) => {
            const newData: IMoveRequest = {
              ids: editId || collection,
              targetParentId: e as any,
              projectId: projectId as any,
            };
            if (moveAndCopyState === "move") {
              try {
                await moveFileAndFolder(newData);
                // Message.success("文件移动成功！");
                handleRequest({ ...searchData });
                folderRef.current?.getTreeData();
              } catch (e) {
                Message.error(e);
                console.log(e);
              }
            } else {
              try {
                await copyToFileAndFolder(newData);
                Message.success("文件复制成功！");
                handleRequest({ ...searchData });
              } catch (e) {
                Message.error(e);
                console.log(e);
              }
            }
            setCollection([]);
            setMoveModalTitleVisible(false);
            setEditId(null);
          }}
          title={moveAndCopyState === "move" ? "移动文件" : "复制文件"}
          editIds={editId ? [editId] : collection}
        />
      ) : (
        <></>
      )}

      <ClipDrawer
        ref={clipDrawerRef}
        onOk={(v) => {
          console.log("裁剪完成", v);
          setTimeout(() => {
            handleRequest({ ...searchData });
          }, 1000);
        }}
      />

      <ImageCropper
        onCancel={() => {
          setCropperVisible(false);
        }}
        url={cropperUrl}
        onOk={(url) => {
          cropperOk(url);
        }}
        visible={cropperVisible}
      />
    </div>
  );
});

export default Material;
